import { getCookie, setCookie } from '@helpers/cookies';

export const cookieJar = () => ({
  get: (name: string) => {
    return getCookie(name) || '';
  },
  set: (name: string, value: string, expiresInDays: number) => {
    const siteName = window.location.hostname.split('.').slice(-2).join('.');

    setCookie(name, value, {
      expires: expiresInDays,
      domain: siteName,
      path: '/',
      secure: true,
    });
  },
});
